import { homeConstants } from '../_constants/home.constants';

export const fetchBannersStart = () => ({
  type: homeConstants.FETCH_BANNERS_START,
});

export const fetchBannersSuccess = (data) => ({
  type: homeConstants.FETCH_BANNERS_SUCCESS,
  payload: data
});

export const fetchBannersFailure = (errorMessage) => ({
  type: homeConstants.FETCH_BANNERS_FAILURE,
  payload: errorMessage
});

export const fetchHighlightFundsStart = (period) => ({
  type: homeConstants.FETCH_HIGHLIGHT_FUNDS_START,
  payload: period
});

export const fetchHighlightFundsSuccess = (data) => ({
  type: homeConstants.FETCH_HIGHLIGHT_FUNDS_SUCCESS,
  payload: data
});

export const fetchHighlightFundsFailure = (errorMessage) => ({
  type: homeConstants.FETCH_HIGHLIGHT_FUNDS_FAILURE,
  payload: errorMessage
});

export const updateNavFunds = (data) => ({
  type: homeConstants.UPDATE_NAV_FUNDS,
  payload: data
});

export const fetchNavFundsStart = (data) => ({
  type: homeConstants.FETCH_NAV_FUNDS_START,
  payload: data
});

export const fetchNavFundsSuccess = (data) => ({
  type: homeConstants.FETCH_NAV_FUNDS_SUCCESS,
  payload: data
});

export const fetchNavFundsFailure = (errorMessage) => ({
  type: homeConstants.FETCH_NAV_FUNDS_FAILURE,
  payload: errorMessage
});

export const fetchTopSubCategoriesStart = () => ({
  type: homeConstants.FETCH_TOP_SUB_CATEGORIES_START,
});

export const fetchTopSubCategoriesSuccess = (data) => ({
  type: homeConstants.FETCH_TOP_SUB_CATEGORIES_SUCCESS,
  payload: data
});

export const fetchTopSubCategoriesFailure = (errorMessage) => ({
  type: homeConstants.FETCH_TOP_SUB_CATEGORIES_FAILURE,
  payload: errorMessage
});

export const fetchArticlesStart = () => ({
  type: homeConstants.FETCH_ARTICLES_START,
});

export const fetchArticlesSuccess = (data) => ({
  type: homeConstants.FETCH_ARTICLES_SUCCESS,
  payload: data
});

export const fetchArticlesFailure = (errorMessage) => ({
  type: homeConstants.FETCH_ARTICLES_FAILURE,
  payload: errorMessage
});

export const toggleArticleModal = (data) => ({
  type: homeConstants.TOGGLE_ARTICLE_MODAL,
  payload: data
});